import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { TabsContent } from '../ui/tabs';
import { Save, Loader2 } from 'lucide-react';

export const TabPlanejamento = ({
  planejamento,
  setPlanejamento,
  saving,
  handleSavePlanejamento
}) => (
  <TabsContent value="planejamento">
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle>Plano Assistencial</CardTitle>
          <CardDescription>Defina objetivos, intervenções e critérios de alta</CardDescription>
        </div>
        <Button onClick={handleSavePlanejamento} disabled={saving} data-testid="btn-salvar-planejamento">
          {saving ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Save className="h-4 w-4 mr-2" />}
          Salvar
        </Button>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-2">
          <Label htmlFor="objetivos">Objetivos</Label>
          <Textarea
            id="objetivos"
            placeholder="Ex: Controle de dor, reabilitação funcional, cicatrização..."
            value={planejamento?.objetivos || ''}
            onChange={(e) => setPlanejamento({...planejamento, objetivos: e.target.value})}
            rows={3}
            data-testid="input-objetivos"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="intervencoes">Intervenções</Label>
          <Textarea
            id="intervencoes"
            placeholder="Intervenções planejadas por categoria..."
            value={planejamento?.intervencoes || ''}
            onChange={(e) => setPlanejamento({...planejamento, intervencoes: e.target.value})}
            rows={4}
            data-testid="input-intervencoes"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="frequencias">Frequências</Label>
          <Textarea
            id="frequencias"
            placeholder="Ex: Enfermagem 3x/semana, Fisioterapia diária..."
            value={planejamento?.frequencias || ''}
            onChange={(e) => setPlanejamento({...planejamento, frequencias: e.target.value})}
            rows={2}
            data-testid="input-frequencias"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="criterios_alta">Critérios de Alta</Label>
          <Textarea
            id="criterios_alta"
            placeholder="Critérios para alta clínica..."
            value={planejamento?.criterios_alta || ''}
            onChange={(e) => setPlanejamento({...planejamento, criterios_alta: e.target.value})}
            rows={3}
            data-testid="input-criterios-alta"
          />
        </div>
      </CardContent>
    </Card>
  </TabsContent>
);
